const switchesTutorial = {
  module: 'switches',
  moduleName: 'Network Devices',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Network Devices', description: 'Monitor switches, routers, and access points on your network.' },
    { target: '.sw-summary-grid', position: 'bottom', title: 'Port Status', description: 'See port utilization, PoE status, and connected devices at a glance.' },
    { target: '.network-tabs', position: 'bottom', title: 'Views', description: 'Switch between different device categories and network segments.' },
  ],
};
export default switchesTutorial;
